import React, { useCallback, useState } from "react";
import { Button, Spinner } from "reactstrap";

import { useToast } from "hooks/toast";
import { homologar } from "services/onboardingApi";

function Gate({ ok, children, opcional }) {
  return (
    <div className="d-flex align-items-center" style={{ gap: 10, padding: "7px 0", fontSize: 14 }}>
      <span style={{ color: ok ? "#00bf9a" : "#ff8d72", fontWeight: 700 }}>
        {ok ? "✓" : "•"}
      </span>
      <span>{children}</span>
      {opcional && (
        <span className="onb-badge lock" style={{ marginLeft: 4 }}>
          opcional
        </span>
      )}
    </div>
  );
}

// Homologação (H6 / PO1-2433): gate final do Projeto. Obrigatórios: produto,
// usuários e treinamento confirmado. Transportadoras e tabela de frete são
// opcionais no go-live — o wizard reabre no login até completar.
export default function HomologacaoStep({ dados, onHomologado }) {
  const { addToast } = useToast();
  const { checklist, embarcador } = dados;
  const [treinamento, setTreinamento] = useState(false);
  const [homologando, setHomologando] = useState(false);

  const operacional = checklist.statusEmbarcador === "OPERACIONAL";
  const obrigatoriosOk = checklist.produto.done && checklist.usuarios.done;

  const handleHomologar = useCallback(async () => {
    setHomologando(true);
    try {
      await homologar(embarcador.id, { treinamentoRealizado: treinamento });
      addToast({
        place: "tr",
        type: "success",
        title: "Embarcador operacional",
        description: `${embarcador.fantasia} foi homologado e está ativo.`,
        icon: "tim-icons icon-check-2",
      });
      onHomologado();
    } catch (err) {
      const data = err.response && err.response.data;
      addToast({
        place: "tr",
        type: "danger",
        title: "Homologação bloqueada",
        description:
          (data && data.pendencias && data.pendencias.join("\n")) ||
          (data && data.error) ||
          err.message,
        icon: "tim-icons icon-alert-circle-exc",
      });
    } finally {
      setHomologando(false);
    }
  }, [embarcador, treinamento, addToast, onHomologado]);

  if (operacional) {
    return (
      <div className="text-center" style={{ padding: "24px 0" }}>
        <div
          style={{
            width: 54,
            height: 54,
            borderRadius: "50%",
            background: "rgba(0,191,154,.18)",
            color: "#00bf9a",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 26,
            margin: "0 auto 14px",
          }}
        >
          ✓
        </div>
        <h4>Embarcador operacional</h4>
        <p style={{ color: "#9a9a9a", fontSize: 13 }}>
          {embarcador.fantasia} foi homologado e está ativo. O onboarding
          terminou.
        </p>
      </div>
    );
  }

  return (
    <div>
      <Gate ok={checklist.produto.done}>Produto/plano definido</Gate>
      <Gate ok={checklist.identidade.done}>Identidade da matriz preenchida</Gate>
      <Gate ok={checklist.filiais.done} opcional>
        Filiais cadastradas ({checklist.filiais.total})
      </Gate>
      <Gate ok={checklist.usuarios.done}>
        Usuários convidados ({checklist.usuarios.vinculados} vinculados,{" "}
        {checklist.usuarios.convitesPendentes} pendentes)
      </Gate>
      <Gate ok={checklist.transportadoras.done} opcional>
        Transportadoras cadastradas ({checklist.transportadoras.total})
      </Gate>
      <Gate ok={checklist.configuracao.done} opcional>
        Configuração automática aplicada ({checklist.configuracao.parametros}{" "}
        parâmetros, {checklist.configuracao.locaisArquivo} locais)
      </Gate>
      <Gate ok={false} opcional>
        Tabela de frete carregada ou spot habilitado (opcional no go-live)
      </Gate>

      <label
        className="d-flex align-items-center mt-3"
        style={{ gap: 8, fontSize: 14, cursor: "pointer" }}
      >
        <input
          type="checkbox"
          checked={treinamento}
          onChange={(e) => setTreinamento(e.target.checked)}
          style={{ width: 16, height: 16 }}
        />
        Treinamento de usuário Flow realizado
      </label>

      <p style={{ fontSize: 12, color: "#9a9a9a", marginTop: 12 }}>
        Ao homologar, o embarcador sai de <b style={{ color: "#ff8d72" }}>PENDENTE</b>{" "}
        e vira <b style={{ color: "#00bf9a" }}>OPERACIONAL</b>. Passos opcionais
        não bloqueiam; o wizard reabre até completar.
      </p>

      <div className="d-flex justify-content-end">
        <Button
          color="primary"
          onClick={handleHomologar}
          disabled={homologando || !obrigatoriosOk || !treinamento}
        >
          {homologando ? <Spinner size="sm" /> : "Homologar e ativar ✓"}
        </Button>
      </div>
    </div>
  );
}
